<template>
  <div class="ding-talk-login">
    <div id="dingTalk"></div>
    <!-- <iframe
      scrolling="no"
      width="450"
      height="400"
      frameborder="0"
      allowtransparency="true"
      :src="setSrc"
    ></iframe> -->
  </div>
</template>

<script>
export default {
  mounted() {
    var handleLogin=()=>{
      var obj = DDLogin({
        id: "dingTalk",
        goto: this.setSrc,
        style: "border:none;background-color:#FFFFFF;",
        width : "450",
        height: "400"
      })

      var handleMessage = event => {
        var origin = event.origin
        if( origin == "https://login.dingtalk.com" ) { //判断是否来自ddLogin扫码事件。
          var loginTmpCode = event.data
          let url =
          "https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=" +
          this.appid +
          "&response_type=code&scope=snsapi_login" +
          "&redirect_uri=" +
          window.location.protocol + '//' + this.redirect_uri +
          "&state=" +
          this.state +
          "&loginTmpCode=" +
          loginTmpCode

          console.log(loginTmpCode)
          window.location.href = url
        }
      }
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessage, false);
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessage);
      }
    }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://g.alicdn.com/dingding/dinglogin/0.0.5/ddLogin.js'; // 开始下载脚本，异步下载
    // 加载完成后，执行脚本
    if(script.readyState) { //IE
      script.onreadystatechange = function() {
        if(script.readyState === 'complate' || script.readyState === 'loaded') {
          handleLogin()
        }
      }
    } else { // safari, chrome, firefox, opera
      script.onload = function() {
        handleLogin()
      }
    }
    document.head.appendChild(script);
  },
  computed: {
    setSrc() {
      var _url =
        "https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=" +
        this.appid +
        "&response_type=code&scope=snsapi_login" +
        "&redirect_uri=" +
        (window.location.protocol + '//' + this.redirect_uri) +
        "&state=" +
        this.state
      return  encodeURIComponent(_url);
    }
  },
  props: {
    appid: [String, Number],
    redirect_uri: String,
    state: {
      type: String,
      default: "dingTalk"
    }
  }
};
</script>
<style lang="scss">
.ding-talk-login{
  position: relative;
  z-index: 99;
  iframe{
    body{
      background-color: none !important;
    }
  }
}
</style>